'use client'
import { cloneElement, InputHTMLAttributes, ReactElement } from 'react'
import { classNames } from '@/src/helpers/component'
import styles from './FormBlock.module.scss'

export default function Field(_: {
  label: string
  input: ReactElement<InputHTMLAttributes<HTMLInputElement>>
  className?: string
  required?: boolean
  labelAsDiv?: boolean
}) {
  const Tag = _.labelAsDiv ? 'div' : 'label'
  return (
    <Tag className={classNames(styles.field, _.className)}>
      <div>{`${_.label}${_.required ? '' : ' (optional)'}`}</div>
      {cloneElement(_.input, { required: !!_.required, autoComplete: 'off' })}
    </Tag>
  )
}
